import { Row, Col } from "reactstrap";
import { Outlet } from "react-router-dom";
import Sidebar from "components/Sidebar";

const AppContainer = () => {
   return (
        <Row>
            <Col className="sidebar">
                <Sidebar />
            </Col>
            <Col className="right-container">
                <Outlet />
            </Col>
        </Row>
    );
};

export default AppContainer;